import React from "react";
import { withRouter } from "react-router-dom";
import Notifications from "~/components/notifications";

const NotificationsPage = () => {
	return <Notifications />;
};

export default withRouter(NotificationsPage);
